import React from "react";

const features = [
  {
    title: "AI Receptionist (24/7)",
    body:
      "Auto-answers calls and messages after hours or when you’re busy—no missed opportunities.",
    icon: "📞",
  },
  {
    title: "Appointment Booking",
    body:
      "Instantly schedules showings and consults on your calendar with confirmations and reminders.",
    icon: "📅",
  },
  {
    title: "Lead Generation",
    body:
      "Capture, qualify, and route new leads from web chat, SMS, Facebook Messenger, and email.",
    icon: "🚀",
  },
  {
    title: "Smart Q&A",
    body:
      "Answers FAQs, property questions, pricing, and policies using your own content.",
    icon: "💬",
  },
  {
    title: "Spam & Bot Filtering",
    body:
      "Detects low-quality inquiries to protect your time and keep your pipeline clean.",
    icon: "🛡️",
  },
  {
    title: "Fair-Housing Safe",
    body:
      "Guardrails to keep replies compliant and unbiased—protect your brand and clients.",
    icon: "✅",
  },
];

export default function Features() {
  return (
    <section className="lk-section">
      <div className="lk-container">
        <h2>What You Get</h2>
        <p className="lk-lead">
          Everything you need to capture, qualify, and convert—on autopilot.
        </p>
        <div className="lk-grid">
          {features.map((f) => (
            <div className="lk-card" key={f.title}>
              <div className="lk-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
